var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoodles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.4104C0.113906 10.4048 0.808164 12.2872 2.02562 13.8859C3.22852 15.4656 4.90043 16.6684 6.76895 17.3068V18.6389H13.231V17.3068C15.0995 16.6684 16.7715 15.4656 17.9743 13.8859C19.1918 12.2872 19.8861 10.4048 20 8.4104H0Z",
    fill: "#E9A5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7299 3.71094C14.5095 3.71094 14.2932 3.72852 14.082 3.76207C14.307 4.11879 14.5034 4.49523 14.6676 4.88828C14.6884 4.88785 14.709 4.88672 14.7299 4.88672C16.1482 4.88672 17.3348 5.89746 17.6075 7.23645H18.8006C18.5148 5.24594 16.7982 3.71094 14.7299 3.71094Z",
    fill: "#E9A5F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0566 6.09106C15.1433 6.46321 15.2027 6.84563 15.2326 7.23626H16.3925C16.1854 6.65153 15.678 6.20794 15.0566 6.09106Z",
    fill: "#E9A5F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61934 1.36108C4.25398 1.36108 1.48125 3.94714 1.18359 7.23632H2.36574C2.65867 4.59659 4.90281 2.5369 7.61934 2.5369C10.3359 2.5369 12.58 4.59667 12.873 7.23632H13.0685H14.0551C13.7575 3.94714 10.9847 1.36108 7.61934 1.36108Z",
    fill: "#E9A5F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61953 3.71094C5.55121 3.71094 3.83453 5.2459 3.54883 7.23645H4.74188C5.01457 5.89746 6.20121 4.88672 7.61953 4.88672C9.03785 4.88672 10.2245 5.89746 10.4971 7.23645H10.6602H11.6902C11.4045 5.24594 9.68789 3.71094 7.61953 3.71094Z",
    fill: "#E9A5F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61934 6.06055C6.85305 6.06055 6.19938 6.55203 5.95703 7.23633H9.2816C9.03934 6.55203 8.38566 6.06055 7.61934 6.06055Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoodles);
export default __webpack_public_path__ + "static/media/noodles.8d4e2bc2caef9aaa5312a62e8b88078a.svg";
export { ForwardRef as ReactComponent };